import { useQuery } from "@tanstack/react-query";
import { RefreshReactQuery } from "../constants/AppConstants";

export const useCertificateModal = ({
  idKeyApi,
  certificateApi,
  isOpen,
}: {
  idKeyApi?: string;
  certificateApi?: () => Promise<ArrayBuffer>;
  isOpen: boolean;
}) => {
  const { data, isLoading } = useQuery({
    queryKey: [`get-certificate-${idKeyApi}`],
    queryFn: certificateApi!,
    enabled: !!certificateApi && isOpen && !!idKeyApi,
    staleTime: RefreshReactQuery.INFINITY,
  });

  return { data, isLoading };
};
